import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
class PageHeader {
    init() {
        window.addEventListener("load", () => {
            this.openDoorAnimation();
        });
    }
    openDoorAnimation() {
        const pageHeader = document.querySelector('.page-header');
        const pageHeaderDoor = pageHeader.querySelector('.page-header__door');
        const pageHeaderTl = gsap.timeline();
        pageHeaderTl.to(pageHeaderDoor, { duration: 1, rotationY: -90 });
    }
}

export default PageHeader